export const buttonStyles = {
  base: `
    inline-flex items-center justify-center
    font-medium rounded-lg
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-offset-2
    disabled:opacity-50 disabled:cursor-not-allowed
  `,
  
  variants: {
    primary: `
      bg-gradient-to-r from-primary-400 to-primary-500
      text-white
      hover:from-primary-500 hover:to-primary-600
      focus:ring-primary-400
      shadow-md hover:shadow-lg
      hover:scale-105
      active:scale-95
    `,
    secondary: `
      bg-gray-100 text-gray-700
      hover:bg-gray-200
      focus:ring-gray-400
    `,
    outline: `
      bg-transparent
      border-2 border-primary-400
      text-primary-600
      hover:bg-primary-50
      focus:ring-primary-400
    `,
    ghost: `
      bg-transparent
      text-primary-600
      hover:bg-primary-50
      focus:ring-primary-400
    `,
    danger: `
      bg-red-500 text-white
      hover:bg-red-600
      focus:ring-red-400
      shadow-md hover:shadow-lg
    `,
    success: `
      bg-green-500 text-white
      hover:bg-green-600
      focus:ring-green-400
      shadow-md hover:shadow-lg
    `,
  },
  
  sizes: {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
    xl: 'px-8 py-4 text-xl',
  },
};